export default __webpack_public_path__ + "static/media/thumbnail.f47473ef.png";